import React, { useContext, useState } from "react";
import "./Dashboard_header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";

function Dashboard_header() {
  const [lang, setLang] = useState("EN");

  const isEN = lang === "EN";

  const { userdata } = useContext(Context);

  console.log(userdata, "userdata");
  

  return (
    <>
      <section className="Dashboard_header">
        <div className="header_container">
          {/* LEFT SIDE */}
          <div className="left_section">
            <Link to={"/"}>
              <div className="logo_img_holder">
                <img
                  src="/assets/images/logo/dashboard_logo.png"
                  alt="logo_img"
                  className="logo_img"
                />
              </div>
            </Link>
          </div>

          {/* RIGHT SIDE */}
          <div className="right_section">
            {/* Language button */}
            <button
              className="lang_btn"
              onClick={() => setLang(isEN ? "FR" : "EN")}
              type="button"
            >
              {isEN ? (
                <>
                  <span className="lang_text">EN</span>
                  <img
                    src="/assets/images/common-card/study-program/flag_3.webp"
                    alt="EN flag"
                    className="flag_img"
                  />
                </>
              ) : (
                <>
                  <img
                    src="/assets/images/common-card/study-program/flag-2.png"
                    alt="FR flag"
                    className="flag_img"
                  />
                  <span className="lang_text">FR</span>
                </>
              )}
            </button>
            {/* Notification */}
            <div className="notification_icon">
              <FontAwesomeIcon icon={faBell} className="bell" />
              <span className="count_holder">1</span>
            </div>

            {/* User */}
            <div className="user_section">
              <div className="user_text">
                <p className="user_name">{userdata?.name}</p>
                {/* <span className="user_id">ID: AD548456</span> */}
              </div>

              <div className="user_img_holder">
                <img
                  src="/assets/images/profile/profile_1.webp"
                  alt="user"
                  className="user_img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Dashboard_header;
